import { useFormikContext } from 'formik';
import { type MouseEventHandler } from 'react';

import { Button } from '@hivebrite/design-system/Button';

import { shouldConsiderFormValid } from 'hb-react/shared/components/formik/utils/shouldDisplayError';

import { type SubmitButtonProps } from '../types';

export const SubmitButton = ({ isEditingPost }: SubmitButtonProps) => {
  const { errors, handleSubmit, isSubmitting, isValid, submitCount, touched } =
    useFormikContext();

  return (
    <Button
      isDisabled={
        isSubmitting ||
        !shouldConsiderFormValid({ errors, isValid, submitCount, touched })
      }
      isLoading={isSubmitting}
      ml={3}
      onClick={handleSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
      type="submit"
    >
      {isEditingPost ? __('Save changes') : __('Publish')}
    </Button>
  );
};
